import api from '../common/helpers/apiHelper';
import { IListData } from '../common/models/common/IListData';
import { IFilter } from '../common/models/filter/IFilter';
import { IProspect } from '../common/models/prospect/IProspect';
import { mapSortToSortReq, mapFilterToFilterReq } from '../common/helpers/filterHelper';
import { IProspectStatus } from '../common/models/prospect/IProspectStatus';
import { ProspectStatus } from '../common/enums/ProspectStatus';
import { IProspectCreate } from '../common/models/prospect/IProspectCreate';
import { IUpdateOwner } from '../common/models/candidate/IUpdateOwner';
import { getCode, key } from '../common/helpers/common';

export const getProspects = (payload: IFilter) => api.get<IListData<IProspect>>(
  '/api/prospects/',
  { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
);

export const updateStatus = (payload: IProspectStatus) => api.put('/api/prospects/status', payload);

export const getProspectCounters = (payload: IFilter) => api.get<Record<ProspectStatus, number>>(
  '/api/prospects/counters',
  { ...payload, sort: mapSortToSortReq(payload.sort), filter: mapFilterToFilterReq(payload.filter) }
);

export const createProspect = (payload: IProspectCreate) => api.post(
  `/reference-api/prospect?key=${key}&code=${getCode()}`,
  payload
);

export const createProspectManually = (payload: IProspectCreate) => api.post(
  '/api/prospects', payload
);

export const updateProspectOwner = ({ ids, owner: { id } }: IUpdateOwner) => (
  api.put('/api/prospects/owner', { ids, ownerId: id })
);
